/* eslint-disable react/jsx-key */
import React from "react";
import styled from "styled-components";
import useRouting from "../hooks/useRouting.js";
import { useParams } from "react-router";
import i18n from "../i18n";
import { ActionButton } from "wg-fe-ui";
import CheckBoxBorderedBlockWithIcon from "../components/CheckBoxBorderedBlockWithIcon.jsx";
import { patchStorage, retrieveStorageById } from "../helpers/storeService";
import { getThemeObject } from "../helpers/themingService.js";
import louise_logo from "../assets/images/louise_logo.svg";
import { parseIntSafely } from "../helpers/intService";

const FlowSafetySystem = () => {
  const defaultImg = louise_logo;
  const { renderNextRoute } = useRouting();
  const { id, affinity, insuranceType } = useParams();
  const { data } = retrieveStorageById(id, affinity, insuranceType);
  const carBrandImage = data?.car?.details?.carImg || defaultImg;

  const colors = getThemeObject(affinity).brand.primary;

  const drive_assistance_system = data?.car?.details
    ?.driveAssistanceSystems || {
    automatic_emergency_braking: false,
    adaptive_cruise_control: false,
    lane_support: false,
    blind_spot_check: false,
    attention_assist: false,
    ecall: false,
    automatic_parking: false,
    parking_aid: false,
  };

  function handleChange({ type, value }) {
    drive_assistance_system[type] = value;
  }

  const questions = [
    {
      type: "automatic_emergency_braking",
      value: "AEB (Automatic Emergency Braking)",
    },
    {
      type: "adaptive_cruise_control",
      value: "Adaptive Cruise Control",
    },
    { type: "lane_support", value: "Lane Support" },
    { type: "blind_spot_check", value: "Dodehoekcontrole" },
    { type: "attention_assist", value: "Attention Assist" },
    { type: "ecall", value: "eCall" },
    { type: "automatic_parking", value: "Automatisch Parkeren" },
    { type: "parking_aid", value: "Parking Aid" },
  ];

  function handleSubmit(driveAssistanceSystems) {
    patchStorage({
      payload: {
        car: {
          ...data?.car,
          details: { ...data?.car?.details, driveAssistanceSystems },
        },
      },
      id,
      affinity,
      insuranceType,
    });
    if (insuranceType === "two-wheeler") {
      // 1. BikePriceCalculation
      // 2. LightScooterPriceCalculation
      // 3. NotAcceptedPage
      if (data?.twoWheeler?.details?.vehicleType === "LIGHT_SCOOTER") {
        isPersonAccepted() ? renderNextRoute(2) : renderNextRoute(3);
      } else {
        isPersonAccepted() ? renderNextRoute(1) : renderNextRoute(3);
      }
    } else if (insuranceType === "6-wheeler") {
      // 1. CarPriceCalculation
      // 2. StartBikeFlowPage
      // 3. NotAcceptedPage
      if (data?.selectedFormula === "MOTOR_ALREADY_INSURED") {
        isPersonAccepted() ? renderNextRoute(1) : renderNextRoute(3);
      } else if (data?.selectedFormula === "MOTOR_COMPANY_CAR") {
        // 1. BikePriceCalculation
        // 2. LightScooterPriceCalculation
        // 3. NotAcceptedPage
        if (data?.selectedFormula === "LIGHT_SCOOTER") {
          isPersonAccepted() ? renderNextRoute(2) : renderNextRoute(3);
        } else {
          isPersonAccepted() ? renderNextRoute(1) : renderNextRoute(3);
        }
      } else if (data?.selectedFormula === "6WHEELS") {
        isPersonAccepted() ? renderNextRoute(2) : renderNextRoute(3);
      }
    } else {
      // 1. CarPriceCalculation
      // 2. NotAcceptedPage
      isPersonAccepted() ? renderNextRoute(1) : renderNextRoute(2);
    }
  }

  function getAge(dateString) {
    var today = new Date();
    const newDateString = dateString.split("/");
    let newVal =
      newDateString[1] + "/" + newDateString[0] + "/" + newDateString[2];
    var birthDate = new Date(newVal);
    console.log(newVal);

    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  function isPersonAccepted() {
    const { data } = retrieveStorageById(id, affinity, insuranceType);
    console.log(data);
    if (
      insuranceType === "car" ||
      (insuranceType === "6-wheeler" &&
        ["MOTOR_ALREADY_INSURED", "6WHEELS"].includes(data?.selectedFormula))
    ) {
      const birthDateString = data?.car?.mainDriver?.birth;
      let age = getAge(birthDateString);
      let driverLicenseAge = getAge(data?.car?.mainDriver?.issueLicenseDate);
      const bm = parseInt(data?.car?.mainDriver?.bonusMalus);
      const claimsInFault = parseIntSafely(
        data?.car?.mainDriver?.claims_in_fault
      );
      if (age < 18) {
        patchStorage({
          payload: { rejectionDescription: i18n.t(`Age < 18`) },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else if (claimsInFault > 2) {
        patchStorage({
          payload: {
            rejectionDescription: i18n.t(`No. of claims last 5 years > 2`),
          },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else if (data?.car?.details?.kw > 200) {
        patchStorage({
          payload: { rejectionDescription: i18n.t(`Car KW > 200`) },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else if (data?.car?.details?.catalogueValue > 75000) {
        patchStorage({
          payload: { rejectionDescription: i18n.t(`Car value > 75000`) },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else if (data?.car?.mainDriver?.driverLicenseType === "PROVISIONAL") {
        patchStorage({
          payload: {
            rejectionDescription: i18n.t(`Main driver has provisional license`),
          },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else if (age < 25 && affinity === 'honda' && data?.car?.details?.kw > 90) {
        patchStorage({
          payload: { rejectionDescription: i18n.t(`Age < 25 & Car KW > 90`) },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else if (age < 25 && affinity !== 'honda' && data?.car?.details?.kw > 85) {
        patchStorage({
          payload: { rejectionDescription: i18n.t(`Age < 25 & Car KW > 85`) },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else if (age < 25 && claimsInFault > 0) {
        patchStorage({
          payload: {
            rejectionDescription: i18n.t(
              `Age < 25 & No. of claims last 5 years > 0`
            ),
          },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else if (
        age < 30 &&
        driverLicenseAge < 1 &&
        affinity !== 'honda' &&
        data?.car?.details?.kw > 85
      ) {
        patchStorage({
          payload: {
            rejectionDescription: i18n.t(
              `Age < 30 & Less than one year driver license & Car KW > 85`
            ),
          },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else if (
        age < 30 &&
        driverLicenseAge < 1 &&
        affinity === 'honda' &&
        data?.car?.details?.kw > 85
      ) {
        patchStorage({
          payload: {
            rejectionDescription: i18n.t(
              `Age < 30 & Less than one year driver license & Car KW > 90`
            ),
          },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else if (age < 30 && driverLicenseAge < 1 && claimsInFault > 0) {
        patchStorage({
          payload: {
            rejectionDescription: i18n.t(
              `Age < 30 & Less than one year driver license & No. of claims last year > 0`
            ),
          },
          id,
          affinity,
          insuranceType,
        });
        return false;
      // } else if (age > 75) {
      //   patchStorage({
      //     payload: { rejectionDescription: i18n.t(`Age > 75`) },
      //     id,
      //     affinity,
      //     insuranceType,
      //   });
      //   return false;
      } else if (bm > 11) {
        patchStorage({
          payload: { rejectionDescription: i18n.t(`Bonus malus > 11`) },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else if (age >= 65 && bm > 3) {
        patchStorage({
          payload: {
            rejectionDescription: i18n.t(`Age > 65 & Bonus malus > 3`),
          },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else {
        return true;
      }
    }

    if (
      insuranceType === "two-wheeler" ||
      (insuranceType === "6-wheeler" &&
        ["MOTOR_COMPANY_CAR", "CAR_ALREADY_INSURED", "6WHEELS"].includes(
          data?.selectedFormula
        ))
    ) {
      const birthDateString = data?.twoWheeler?.mainDriver?.birth;
      let age = getAge(birthDateString);
      let driverLicenseAge = data?.twoWheeler?.mainDriver?.issueLicenseDate
        ? getAge(data?.twoWheeler?.mainDriver?.issueLicenseDate)
        : null;
      const claimsInFault = parseIntSafely(
        data?.twoWheeler?.mainDriver?.claims_in_fault
      );
      if (driverLicenseAge !== null && age < 18) {
        patchStorage({
          payload: { rejectionDescription: i18n.t(`Age < 18`) },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else if (claimsInFault > 2) {
        patchStorage({
          payload: {
            rejectionDescription: i18n.t(`No. of claims last 5 years > 2`),
          },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else if (data?.twoWheeler?.details?.cc > 2000) {
        patchStorage({
          payload: { rejectionDescription: i18n.t(`Moto CC > 2000`) },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else if (
        data?.twoWheeler?.mainDriver?.driverLicenseType === "PROVISIONAL"
      ) {
        patchStorage({
          payload: {
            rejectionDescription: i18n.t(`Main driver has provisional license`),
          },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else if (
        driverLicenseAge != null &&
        age < 25 &&
        data?.twoWheeler?.details?.cc > 2000
      ) {
        patchStorage({
          payload: {
            rejectionDescription: i18n.t(`Age < 25 & Moto CC > 2000`),
          },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else if (driverLicenseAge != null && age < 25 && claimsInFault > 0) {
        patchStorage({
          payload: {
            rejectionDescription: i18n.t(
              `Age < 25 & No. of claims last 5 years > 0`
            ),
          },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else if (
        driverLicenseAge !== null &&
        age < 30 &&
        driverLicenseAge < 1 &&
        data?.twoWheeler?.details?.cc > 2000
      ) {
        patchStorage({
          payload: {
            rejectionDescription: i18n.t(
              `Age < 30 & Less than one year driver license & Moto CC > 2000`
            ),
          },
          id,
          affinity,
          insuranceType,
        });
        return false;
      } else if (
        driverLicenseAge != null &&
        age < 30 &&
        driverLicenseAge < 1 &&
        claimsInFault > 0
      ) {
        patchStorage({
          payload: {
            rejectionDescription: i18n.t(
              `Age < 30 & Less than one year driver license & No. of claims last year > 0`
            ),
          },
          id,
          affinity,
          insuranceType,
        });
        return false;
      // } else if (age > 75) {
      //   patchStorage({
      //     payload: { rejectionDescription: i18n.t(`Age > 75`) },
      //     id,
      //     affinity,
      //     insuranceType,
      //   });
      //   return false;
      } else {
        return true;
      }
    }

    return true;
  }

  return (
    <SplitContainer>
      <LeftSplit>
        <RoundImageContainer>
          <RoundImage img={carBrandImage} alt="car brand logo" />
        </RoundImageContainer>
        <TextBalloon>
          <p
            dangerouslySetInnerHTML={{
              __html: i18n.t(
                `I also need to know what driving aid systems are available on your car`
              ),
            }}
          ></p>
        </TextBalloon>
      </LeftSplit>
      <RightSplit>
        <TitleForm>{i18n.t("Safety Systems")}</TitleForm>
        <div>
          {questions.map((question) => {
            return (
              <CheckBoxBorderedBlockWithIcon
                key={question}
                initial={drive_assistance_system[question.type]}
                onChange={(value) => handleChange(value)}
                question={question}
                colors={colors}
              />
            );
          })}
        </div>
        <ButtonContainer>
          <StyledActionButton
            affinity={affinity}
            onClick={() => handleSubmit(drive_assistance_system)}
          >
            {i18n.t("Next")}
          </StyledActionButton>
        </ButtonContainer>
      </RightSplit>
    </SplitContainer>
  );
};

const StyledActionButton = styled(ActionButton)`
  color: ${({ affinity }) => (affinity === "de-lijn" ? "black" : "white")};
  background-color: ${({ affinity }) =>
    affinity === "callant" || affinity === "uber" || affinity === "at-work"
      ? "#94C11A"
      : "default"};
  font-weight: ${({ affinity }) => (affinity === "de-lijn" ? "700" : "normal")};
`;

const ButtonContainer = styled.div`
  align-items: center;
  display: flex;

  margin-top: 2rem;

  & button {
    margin-left: auto;
    width: 20rem;
    @media (max-width: 768px) {
      width: 100%;
    }
  }
`;

const TitleForm = styled.h2`
  font-weight: 900;
  font-size: 1.6rem;
  flex-shrink: 0;
  margin-bottom: 2rem;
`;

const TextBalloon = styled.div`
  display: flex;
  font-size: 1.6rem;
  line-height: 1.5;
  align-self: center;
  width: 100%;
  padding: 2.2rem;
  border-radius: 0.5rem;
  color: #393939;
  background: #f3f3f3;
  margin-top: auto;
  > span {
    font-weight: 700;
  }
`;

const RightSplit = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 5rem 4rem;
  overflow-y: auto;

  @media (max-width: 768px) {
    width: 100%;
  }

  @media screen and (max-width: 425px) {
    padding: 4rem 2.5rem;
  }
`;

const SplitContainer = styled.div`
  display: flex;
  height: 100%;
`;

const LeftSplit = styled.div`
  width: 50%;
  display: grid;
  grid-template-rows: 71% 25%;
  grid-gap: 2rem;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  padding: 5rem 4rem;

  :after {
    content: "";
    width: 1px;
    height: 70%;
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
    right: 50%;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const RoundImage = styled.div`
  background-image: url(${(props) => props.img});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  width: 100%;
  height: auto;
  padding-top: 100%;
`;

const RoundImageContainer = styled.div`
  max-width: 35rem;
  width: 100%;
  margin: auto;
`;

export default FlowSafetySystem;
